var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14435 3.62802C8.93095 1.66702 9.32425 0.686523 10.0006 0.686523C10.6769 0.686523 11.0702 1.66702 11.8568 3.62802L11.8934 3.71934C12.3378 4.82721 12.56 5.38114 13.0129 5.71783C13.4657 6.05452 14.0602 6.10776 15.2491 6.21423L15.464 6.23348C17.4099 6.40774 18.3828 6.49488 18.5909 7.11386C18.7991 7.73284 18.0766 8.39019 16.6316 9.70487L16.1493 10.1436C15.4178 10.8092 15.052 11.1419 14.8815 11.5781C14.8497 11.6594 14.8233 11.7428 14.8024 11.8276C14.6903 12.2822 14.7975 12.765 15.0117 13.7304L15.0783 14.031C15.472 15.8053 15.6688 16.6925 15.3252 17.0751C15.1967 17.2181 15.0298 17.3211 14.8444 17.3717C14.3482 17.5071 13.6437 16.933 12.2348 15.7849C11.3096 15.031 10.847 14.6541 10.3159 14.5693C10.107 14.5359 9.89414 14.5359 9.68524 14.5693C9.15413 14.6541 8.69155 15.031 7.76638 15.7849C6.35742 16.933 5.65295 17.5071 5.15675 17.3717C4.97133 17.3211 4.80442 17.2181 4.676 17.0751C4.33232 16.6925 4.52915 15.8053 4.92283 14.031L4.9895 13.7304C5.20371 12.765 5.31082 12.2822 5.19876 11.8276C5.17786 11.7428 5.15142 11.6594 5.11962 11.5781C4.94915 11.1419 4.5834 10.8092 3.85189 10.1436L3.36961 9.70487C1.92456 8.39019 1.20204 7.73284 1.41022 7.11386C1.6184 6.49488 2.59131 6.40774 4.53712 6.23348L4.75206 6.21423C5.94097 6.10775 6.53543 6.05452 6.98828 5.71783C7.44113 5.38114 7.66333 4.8272 8.10772 3.71934L8.14435 3.62802Z",
    stroke: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0da06b17428798c7861f9f823cdd32c0.svg";
export { ForwardRef as ReactComponent };